
<!-- <app-subnav></app-subnav> -->
<div class="container" style="text-align: justify;">
    <h3>TERMS AND CONDITIONS</h3>
    <ol>
    <h4>Please read all these terms and conditions.</h4>
    <p>
        As we can accept your order and make a legally enforceable
        agreement without further reference to you, you must read these terms and
        conditions to make sure that they contain all that you want and nothing that you are not happy with.
        If you are not sure about anything, just phone us on (+44) 01223 362994.
    </p>
        <h4>Application</h4>
        <li>These Terms and Conditions will apply to the purchase of the services and goods by you
            (the Customer or you).</li>
        <li>
            We are Foodbud Limited a company registered in England and Wales under number 13163110 whose registered
            office is at 9 Pye Terrace,  Cambridge,  Cambridgeshire, CB4 1DX  with email address <a href="info@foodbud.ai">info@foodbud.ai</a> ; 
            telephone number <strong>((+44) 01223 362994) (the Supplier or us or we).</strong> 
        </li>
        <li>
            These are the terms on which we sell all Services to you. By ordering any of the Services,
            you agree to be bound by these Terms and Conditions.
        </li>
        <h4>Interpretation</h4>
        <li>Consumer means an individual acting for purposes which are wholly or mainly outside his or her trade,
            business, craft or profession;</li>
        <li>Contract means the legally-binding agreement between you and us for the supply of the Services;</li>
        <li>Delivery Location means the Supplier's premises or other location where the Services are to be supplied,
            as set out in the Order;</li>
        <li>Goods means any goods that we supply to you with the Services, of the number and description as set out in
            the Order;</li>
        <li>Order means the Customer's order for the Services from the Supplier as set out overleaf;</li>
        <li>Services means the services, including any Goods, of the number and description set out in the Order.</li>
        <h4>Services</h4>
        <li>The description of the Services and any Goods is as set out in our website, catalogues, brochures or other
            form of advertisement.
            Any description is for illustrative purposes only and there may be small discrepancies in size or colour of
            any Goods supplied.</li>
        <li>In the case of Services and any Goods made to your special requirements, it is your responsibility to ensure
            that any information or specification you provide is accurate.</li>
        <li>All Services are subject to availability.</li>
        <li>We can make changes to the Services which are necessary to comply with any applicable law or safety
            requirement.
            We will notify you of these changes.</li>
        <h4>Customer responsibilities</h4>
        <li>You must co-operate with us in all matters relating to the Services,
            provide us and our authorised employees and representatives with access to any premises under your control
            as required,
            provide us with all information required to perform the Services and obtain any necessary licences and
            consents (unless otherwise agreed).</li>
        <li>Failure to comply with the above is a Customer default which entitles us to suspend performance of the
            Services until you remedy it or if you fail to remedy it following our request,
            we can terminate the Contract with immediate effect on written notice to you.</li>
        <h4>Basis of Sale</h4>
        <li>The description of the Services and any Goods in our website,
            catalogues, brochures or other form of advertisement does not constitute a contractual offer to sell the
            Services or Goods.</li>
        <li>When an Order has been made, we can reject it for any reason, although we will try to tell you the reason
            without delay.</li>
        <li>A Contract will be formed for the Services ordered, only upon  the Supplier sending an email to the Customer
            saying that the Order has been accepted  or, if earlier,
            the Supplier's delivery of the Services to the Customer.</li>
        <li>Any quotation or estimate of Fees (as defined below) is valid for a maximum period of  14   days  from its
            date,
            unless we expressly withdraw it at an earlier time.</li>
        <li>No variation of the Contract, whether about description of the Services, Fees or otherwise, can be made
            after it has been entered into unless the variation is agreed by the Customer and the Supplier in writing.
        </li>
        <li>We intend that these Terms and Conditions apply only to a Contract entered into by you as a Consumer where
            we, the Supplier and you the Customer, enter the Contract at any of the Supplier's business premises, and
            where the Contract is not a contract (i) for which an offer was made by the Customer in the Supplier's and
            the Customer's simultaneous physical presence away from those premises, or (ii) made immediately after the
            Customer was personally and individually addressed in the Supplier's and the Customer's simultaneous
            physical presence away from those premises. If this is not the case, you must tell us, so that we can
            provide you with a different contract with terms which are more appropriate to you and which might, in some
            way, be better for you, eg by giving cancellation rights pursuant to consumer protection law. Business
            premises means immovable retail premises where we carry on business on a permanent basis or,
            in the case of movable retail premises, on a usual basis.</li>
        <h4>Fees and Payment</h4>
        <li>The fees (Fees) for the Services, the price of any Goods (if not included in the Fees) and any additional
            delivery or other charges is that set out in our price list current at the date of the Order or such other
            price as we may agree in writing. Prices for Services may be calculated on a fixed fee or on a standard rate
            basis.</li>
        <li>Fees and charges include VAT at the rate applicable at the time of the Order.</li>
        <li>Payment for Services must be made  within  7  days of invoice.   You must pay in cash or by submitting your
            credit or debit card details with your Order and we can take payment immediately or otherwise before
            delivery of the Services.</li>
        <h4>Delivery</h4>
        <li>We will deliver the Services, including any Goods, to the Delivery Location by the time or within the agreed
            period or, failing any agreement:</li>
        <ol type="a">
            <li>in the case of Services, within a reasonable time; and</li>
            <li>in the case of Goods, without undue delay and, in any event, not more than 30 calender days from the day
                on which the Contract is entered into.</li>
        </ol>
        <li>In any case, regardless of events beyond our control, if we do not deliver the Services on time, you can
            require us to reduce the Fees or charges by an appropriate amount (including the right to receive a refund
            for anything already paid above the reduced amount).
            The amount of the reduction can, where appropriate, be up to the full amount of the Fees or charges.</li>
        <li>In any case, regardless of events beyond our control, if we do not deliver the Goods on time, you can (in
            addition to any other remedies) treat the Contract at an end if:</li>
        <ol type="a">
            <li>we have refused to deliver the Goods, or if delivery on time is essential taking into account all the
                relevant circumstances at the time the Contract was made, or you said to us before the Contract was made
                that delivery on time was essential; or</li>
            <li>after we have failed to deliver on time, you have specified a later period which is appropriate to the
                circumstances and we have not delivered within that period.</li>
        </ol>
        <li>If you treat the Contract at an end, we will (in addition to other remedies) promptly return all payments
            made under the Contract.</li>
        <li>If you were entitled to treat the Contract at an end, but do not do so, you are not prevented from
            cancelling the Order for any Goods or rejecting Goods that have been delivered and, if you do this, we will
            (in addition to other remedies) without delay return all payments made under the Contract for any such
            cancelled or rejected Goods.
            If the Goods have been delivered, you must return them or allow us to collect them from you and we will pay
            the costs of this.</li>
        <li>If any Goods form a commercial unit (a unit is a commercial unit if division of the unit would materially
            impair the value of the goods or the character of the unit) you cannot cancel or reject the Order for some
            of those Goods without also cancelling or rejecting the Order for the rest of them.</li>
        <li>We do not generally deliver to addresses outside England and Wales, Scotland, Northern Ireland, the Isle of
            Man and Channels Islands. If, however, we accept an Order for delivery outside that area, you may need to
            pay import duties or other taxes, as we will not pay them.</li>
        <li>You agree we may deliver the Goods in instalments if we suffer a shortage of stock or other genuine and fair
            reason, subject to the above provisions and provided you are not liable for extra charges.</li>
        <li>If you or your nominee fail, through no fault of ours, to take delivery of the Services at the Delivery
            Location, we may charge the reasonable costs of storing and redelivering them.</li>
        <li>The Goods will become your responsibility from the completion of delivery or Customer collection. You must,
            if reasonably practicable, examine the Goods before accepting them.</li>
        <h4>Risk and Title</h4>
        <li>Risk of damage to, or loss of, any Goods will pass to you when the Goods are delivered to you.</li>
        <li>You do not own the Goods until we have received payment in full. If full payment is overdue or a step occurs
            towards your bankruptcy, we can choose, by notice to cancel any delivery and end any right to use the Goods
            still owned by you, in which case you must return them or allow us to collect them.</li>
        <h4>Withdrawal</h4>
        <li>You can withdraw the Order by telling us before the Contract is made, if you simply wish to change your mind
            and without giving us a reason, and without incurring any liability.</li>
        <h4>Conformity</h4>
        <li>We have a legal duty to supply the Goods in conformity with the Contract, and will not have conformed if it
            does not meet the following obligation.</li>
        <li>Upon delivery, the Goods will:</li>
        <ol type="a">
            <li>be of satisfactory quality;</li>
            <li>be reasonably fit for any particular purpose for which you buy the Goods which, before the Contract is
                made, you made known to us (unless you do not actually rely, or it is unreasonable for you to rely, on
                our skill and judgment) and be fit for any purpose held out by us or set out in the Contract; and</li>
            <li>conform to their description.</li>
        </ol>
        <li>It is not a failure to conform if the failure has its origin in your materials.</li>
        <li>We will supply the Services with reasonable skill and care.</li>
        <li>In relation to the Services, anything we say or write to you, or anything someone else says or writes to you
            on our behalf, about us or about the Services, is a term of the Contract (which we must comply with) if you
            take it into account when deciding to enter this Contract, or when making any decision about the Services
            after entering into this Contract. Anything you take into account is subject to anything that qualified it
            and was said or written to you by us or on behalf of us on the same occasion, and any
            change to it that has been expressly agreed between us (before entering this Contract or later).</li>
        <h4>Duration, termination and suspension</h4>
        <li>The Contract continues as long as it takes us to perform the Services.</li>
        <li>Either you or we may terminate the Contract or suspend the Services at any time by a written notice of
            termination or suspension to the other if that other:</li>
        <ol type="a">
            <li>commits a serious breach, or series of breaches resulting in a serious breach, of the Contract and the
                breach either cannot be fixed or is not fixed within 30 days of the written notice; or</li>
            <li>is subject to any step towards its bankruptcy or liquidation.</li>
        </ol>
        <li>On termination of the Contract for any reason,
            any of our respective remaining rights and liabilities will not be affected.</li>
        <h4>Privacy</h4>
        <li>Your privacy is critical to us. We respect your privacy and comply with the General Data Protection
            Regulation with regard to your personal information.</li>
        <li>These Terms and Conditions should be read alongside, and are in addition to our policies, including our
            privacy policy and cookies policy which can be found on our website.</li>
        <li>For the purposes of these Terms and Conditions:</li>
        <ol type="a">
            <li> 'Data Protection Laws' means any applicable law relating to the processing of Personal Data, including,
                but not limited to the GDPR.</li>
            <li>'GDPR' means the UK General Data Protection Regulation.</li>
            <li>'Data Controller', 'Personal Data' and 'Processing' shall have the same meaning as in the GDPR.</li>
        </ol>
        <li>We are a Data Controller of the Personal Data we Process in providing the Services and Goods to you.</li>
        <li>Where you supply Personal Data to us so we can provide Services and Goods to you, and we Process that
            Personal Data in the course of providing the Services and Goods to you, we will comply with our obligations
            imposed by the Data Protection Laws:</li>
        <ol type="a">
            <li>before or at the time of collecting Personal Data, we will identify the purposes for which information
                is being collected;</li>
            <li>we will only Process Personal Data for the purposes identified;</li>
            <li>we will respect your rights in relation to your Personal Data; and</li>
            <li> we will implement technical and organisational measures to ensure your Personal Data is secure.</li>
        </ol>
        <li>For any enquiries or complaints regarding data privacy, you can e-mail: info@foodbud.ai.</li>
        <h4>Successors and our sub-contractors</h4>
        <li>Either party can transfer the benefit of this Contract to someone else, and will remain liable to the other
            for its obligations under the Contract. The Supplier will be liable for the acts of any sub-contractors who
            it chooses to help perform its duties.</li>
        <h4>Circumstances beyond the control of either party</h4>
        <li>In the event of any failure by a party because of something beyond its reasonable control:</li>
        <ol type="a">
            <li>the party will advise the other party as soon as reasonably practicable; and</li>
            <li>the party's obligations will be suspended so far as is reasonable, provided that that party will act
                reasonably, and the party will not be liable for any failure which it could not reasonably avoid,
                but this will not affect the Customer's above rights relating to delivery.</li>
        </ol>
        <h4>Excluding liability</h4>
        <li>We do not exclude liability for: (i) any fraudulent act or omission; or (ii) death or personal injury caused
            by negligence or breach of the Supplier's other legal obligations. Subject to this, we are not liable for
            (i) loss which was not reasonably foreseeable to both parties at the time when the Contract was made, or
            (ii) loss (eg loss of profit) to your business, trade, craft or profession which would not be suffered by a
            Consumer - because we believe you are not buying the Services and Goods wholly or mainly for your business,
            trade, craft or profession.</li>
        <h4>Governing law, jurisdiction and complaints</h4>
        <li>The Contract (including any non-contractual matters) is governed by the law of England and Wales.</li>
        <li>Disputes can be submitted to the jurisdiction of the courts of England and Wales or, where the Customer
            lives in Scotland or Northern Ireland, in the courts of Scotland or Northern Ireland respectively.</li>
        <li>We try to avoid any dispute, so we deal with complaints as follows: If a dispute occurs customers should
            contact us to find a solution. We will aim to respond with an appropriate solution within 7 working days.
        </li>
        <br>
    </ol>
</div>
